import { client } from "./utils";
import { formatAppListResponse } from "./utils/helpers";

export interface ISearchField {
  clientDbId: number;
  module: string;
  field: string;
  pageNumber: number;
  fil: string;
  locale?: string;
  top?: number;
  isList?: number;
  fieldValues?: { [key: string]: any }; 
}

export const searchInField = (
  params: { [key: string]: any },
  config?: Record<string, unknown>
) => {
  const query = {
    clientDbId: params.clientDbId,
    procedureName: "RGI_MSCAN_SEARCH",
    data: {
      module: params.module,
      type: params.field,
      pageNumber: params.pageNumber,
      filter: params.fil || "",
      top: params.top || 100,
      isList: params.isList,
      ...params.fieldValues,  
    },
  };

  return client
    .post("/client/application", query, {
      ...config,
      headers: {
        "accept-language": params.locale || "lt",
      },
    })
    .then(formatAppListResponse);
};
